/** eslint-disable prettier/prettier */
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import { AuthService } from './auth.service';
import { Observable, from, of, throwError } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ActivatedRoute, Router } from '@angular/router';
import Swal, { SweetAlertOptions } from 'sweetalert2';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    public authService: AuthService, 
    private router: Router, 
    private activatedRoute: ActivatedRoute
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return from(this.handleAccess(request, next));
  }

  private async handleAccess(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Promise<HttpEvent<any>> {
    if (request.url.indexOf('login') === -1 && request.url.indexOf('public') === -1) {
      const token = await this.authService.getJWT();
      const entidade = await this.authService.getSession();
      const queryEntidade = this.getQueryEntidade()
      if(queryEntidade !== null && queryEntidade != entidade){
        this.authService.setRedirectTo(window.location.pathname + window.location.search);
        this.router.navigate(['logout'],
          { queryParams: {
            entidade: queryEntidade
          } }
        );
      }
      let changedRequest = request;
      // HttpHeader object immutable - copy values
      const headerSettings: { [name: string]: string | string[] } = {};

      for (const key of request.headers.keys()) {
        headerSettings[key] = request.headers.getAll(key) || '';
      }
      if (token) {
        headerSettings['Authorization'] = 'Bearer ' + token;
        headerSettings['entidade-id'] = String(entidade);
      }
      const newHeader = new HttpHeaders(headerSettings);

      changedRequest = request.clone({
        headers: newHeader,
      });
      return next
        .handle(changedRequest)
        .pipe(catchError((x) => this.handleAuthError(x)))
        .toPromise();
    } else {
      return next.handle(request).toPromise();
    }
  }

  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    //handle your auth error or rethrow

    if (err.status === 403) {
      Swal.fire({
        title: 'Erro',
        text: 'Usuário sem permissão',
        icon: 'error',
        customClass: 'sw-system',
        showConfirmButton:true,
      } as SweetAlertOptions).then( ()=>{
        this.router.navigate(['.'], { relativeTo: this.activatedRoute });
      });
    } else if (err.status === 401) {
      this.authService.cleanJWT();
      window.location.href = window.location.href;
      return of(err.message); // or EMPTY may be appropriate here
    }

    return throwError(err);
  }


  getQueryEntidade(): number{
    const params = new URLSearchParams(window.location.search);
    const entidade = params.get('entidade');
    return entidade? +(entidade) : null;
  }
}
